"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactComponents = require("@cimpress/react-components");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _i18n = require("../i18n");

var _IconUser = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconUser"));

var _reactStreamlineIcons = require("@cimpress-technology/react-streamline-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UserLine = /*#__PURE__*/function (_React$Component) {
  _inherits(UserLine, _React$Component);

  var _super = _createSuper(UserLine);

  function UserLine() {
    _classCallCheck(this, UserLine);

    return _super.apply(this, arguments);
  }

  _createClass(UserLine, [{
    key: "tt",
    value: function tt(key) {
      var _this$props = this.props,
          t = _this$props.t,
          language = _this$props.language;
      return t(key, {
        lng: language
      });
    }
  }, {
    key: "render",
    value: function render() {
      var u = this.props.user || {};
      var profile = u.profile || (u.profiles ? u.profiles[0] : undefined) || u;
      var avatar = this.props.withAvatar && (u.picture || profile.picture) ? /*#__PURE__*/_react["default"].createElement("img", {
        src: u.picture || profile.picture,
        alt: "",
        className: 'rcu-user-avatar'
      }) : null;
      var adminLabel = this.props.withUserType ? u.is_admin ? /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
        contents: this.tt('group_administrator')
      }, "\xA0", /*#__PURE__*/_react["default"].createElement(_IconUser["default"], {
        className: "user-icon-admin"
      })) : /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
        contents: this.tt('group_member')
      }, "\xA0", /*#__PURE__*/_react["default"].createElement(_IconUser["default"], {
        className: "user-icon-member"
      })) : null;
      var meLabel = this.props.isCurrentUser ? /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
        contents: this.tt('this_is_you_tooltip'),
        className: 'rcu-principal-tooltip'
      }, "\xA0", /*#__PURE__*/_react["default"].createElement(_reactStreamlineIcons.IconRatingStarAlt, {
        weight: 'fill',
        color: _reactComponents.colors.info.base
      })) : null;
      var email = profile.email;

      if (!this.props.withEmail) {
        email = null;
      }

      var mutedEmail = email ? this.props.withName ? /*#__PURE__*/_react["default"].createElement("span", {
        className: 'text-muted'
      }, ' ', "(", /*#__PURE__*/_react["default"].createElement("em", null, email), ")", ' ') : email : null;
      var name = profile.name;

      if (this.props.withEmail && this.props.withEmailAsTooltip) {
        mutedEmail = null;
        name = /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
          contents: profile.email || '---'
        }, name);
      }

      if (!this.props.withName || !profile.name) {
        name = null;
      }

      if (profile.name === profile.email && name) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, name, " ", meLabel);
      }

      if (!name && !email || !profile.name && !profile.email) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, avatar, " ", u.principal || u.canonical_principal || u.user_id, adminLabel, meLabel);
      }

      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, avatar, ' ', name, mutedEmail, adminLabel, meLabel);
    }
  }]);

  return UserLine;
}(_react["default"].Component);

UserLine.propTypes = {
  t: _propTypes["default"].any,
  language: _propTypes["default"].string,
  withAvatar: _propTypes["default"].bool,
  withUserType: _propTypes["default"].bool,
  withEmail: _propTypes["default"].bool,
  withName: _propTypes["default"].bool,
  withEmailAsTooltip: _propTypes["default"].bool,
  user: _propTypes["default"].object,
  isCurrentUser: _propTypes["default"].bool
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(UserLine);

exports["default"] = _default;